import { useEffect, useRef, useState } from "react";
import { gsap } from "@/animations/gsap";

interface PreloaderProps {
  onReveal: () => void;
  onDone: () => void;
}

export function Preloader({ onReveal, onDone }: PreloaderProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [count, setCount] = useState(0);
  const revealRef = useRef(onReveal);
  const doneRef = useRef(onDone);
  revealRef.current = onReveal;
  doneRef.current = onDone;

  useEffect(() => {
    const ctx = gsap.context(() => {
      const counter = { v: 0 };
      const tl = gsap.timeline();
      tl.to(".preloader-brand", { opacity: 1, y: 0, duration: 0.5 }, 0.1)
        .to(".preloader-status", { opacity: 1, duration: 0.4 }, 0.3)
        .to(
          counter,
          {
            v: 100,
            duration: 1.0,
            ease: "power2.inOut",
            onUpdate: () => setCount(Math.round(counter.v)),
          },
          0.15
        )
        .to(".preloader-bar-fill", { scaleX: 1, duration: 1.0, ease: "power2.inOut" }, 0.15)
        .add(() => revealRef.current(), "+=0.05")
        .to(ref.current, { yPercent: -100, duration: 0.6, ease: "power4.inOut" })
        .call(() => doneRef.current());
    }, ref);
    return () => ctx.revert();
  }, []);

  return (
    <div ref={ref} className="preloader" data-testid="preloader" aria-hidden="true">
      <p className="preloader-brand">AMOL</p>
      <div className="flex items-end justify-between gap-6">
        <p className="preloader-status pb-3">INITIALIZING...</p>
        <p className="preloader-count">{String(count).padStart(2, "0")}</p>
      </div>
      <div className="preloader-bar">
        <div className="preloader-bar-fill" />
      </div>
    </div>
  );
}
